const config = {
	localhost: window.env.API_URL,
	server:window.env.API_URL,
};
const environment = window.location.hostname === 'localhost' ? 'localhost' : 'server';
//const baseUrl = config[environment];
const baseUrl = window.env.API_URL;

export { baseUrl };
